import { action, computed, observable } from 'mobx';
import { setter, toggle } from 'mobx-decorators';
import * as constants from 'Constants';
import * as utils from 'Utils';
import PhotoMediaStore from 'stores/Model/PhotoMediaStore';
import ScreenshotStore from './ScreenshotStore';
import TestimonialStore from './TestimonialStore';
import { deserializeWithMappers, setFieldValues } from 'stores/Utils';


class ListingStore {

  @setter @observable logoMedia;
  @setter @observable tagline;
  @setter @observable descDelta;
  @setter @observable descHtml;
  @setter @observable websiteUrl;
  @setter @observable contactEmail;

  @setter @observable countryAlpha2;
  @setter @observable region;
  @setter @observable startingPrice;
  @setter @observable languageOptionIds;
  @setter @observable specialityOptionIds;
  @setter @observable platformOptionIds;

  @setter @observable screenshots;
  @setter @observable testimonials;

  static create(data={}) {
    const instance = new ListingStore();
    setFieldValues(instance, data);
    return instance;
  }

  static getDefaults() {
    return {
      "logoMedia": new PhotoMediaStore(),
      "tagline": "",
      "descDelta": {},
      "descHtml": "",
      "websiteUrl": "",
      "contactEmail": "",

      "countryAlpha2": "",
      "region": "",
      "startingPrice": "",
      "languageOptionIds": [],
      "specialityOptionIds": [],
      "platformOptionIds": [],

      "screenshots": [],
      "testimonials": [],
    };
  }

  constructor(defaults=ListingStore.getDefaults()) {
    setFieldValues(this, defaults);
  }

  @action reset(defaults=ListingStore.getDefaults()) {
    setFieldValues(this, defaults);
  }

  getDeserializeMappers() {
    return [
      {"field": "logoMedia", "accessor": "logo_media", "type": constants.DESERIALIZE_TYPE_OBJECT, "cls": PhotoMediaStore},
      {"field": "tagline"},
      {"field": "descDelta", "accessor": "desc_delta"},
      {"field": "descHtml", "accessor": "desc_html"},
      {"field": "websiteUrl", "accessor": "website_url"},
      {"field": "contactEmail", "accessor": "contact_email"},

      {"field": "countryAlpha2", "accessor": "country_alpha2"},
      {"field": "region"},
      {"field": "startingPrice", "accessor": "starting_price"},
      {"field": "languageOptionIds", "accessor": "language_option_ids"},
      {"field": "specialityOptionIds", "accessor": "speciality_option_ids"},
      {"field": "platformOptionIds", "accessor": "platform_option_ids"},

      {"field": "screenshots", "type": constants.DESERIALIZE_TYPE_ARRAY_OBJECTS, "cls": ScreenshotStore},
      {"field": "testimonials", "type": constants.DESERIALIZE_TYPE_ARRAY_OBJECTS, "cls": TestimonialStore},
    ];
  }

  @action deserialize(data) {
    deserializeWithMappers(this, this.getDeserializeMappers(), data);
  }

  @computed get websiteUrlWithUtm() {
    return utils.appendQueryString(this.websiteUrl, {
      'utm_source': 'onvoard'
    })
  }
}



export default ListingStore;

